// example cases
export const caseData = [
    {
        title: 'matildabordin.se',
        img: 'https://matildabordin.se/wp-content/uploads/2019/02/portra%CC%88tt-4-e1551450753668.jpg',
        content: 'Home page for a Swedish actress',
        link: 'https://matildabordin.se'
    },
    {
        title: 'green-leaf.se',
        img: 'https://green-leaf.se/wp-content/uploads/2019/04/tree2.0-icon.png',
        content: 'A social web-game to save the planet',
        link: 'https://green-leaf.se'
    }
];

